import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SketchPicker } from "react-color";
import { BaseInput } from "../../../components";

const ColorInput = ({
  color,
  setColor,
  width,
  styles,
  itemName,
  maxLength = 7,
  hasError = false,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [selectedColor, setSelectedColor] = useState(color);

  const handleColorChange = (newColor) => {
    newColor = newColor.hex ? newColor.hex : newColor.target.value;
    setSelectedColor(newColor);
    setColor(newColor, itemName);
  };

  useEffect(() => {
    setSelectedColor(color);
  }, [color]);

  const handleClose = () => {
    setShowColorPicker(false);
  };

  const pickerStyles = {
    default: {
      picker: {
        borderRadius: "0",
        borderColor: "#E0E0E0",
        touchAction: "none",
      },
    },
  };

  const coverStyle = {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
    zIndex: 9,
  };

  const inputWidth = width ? width : "w-[160px]"

  return (
    <div className="relative inline-block">
      <BaseInput
        className={`pl-8 xl:pl-10 uppercase ${inputWidth}`}
        value={selectedColor}
        maxLength={maxLength}
        hasError={hasError}
        onChange={handleColorChange}
      />
      <div
        className="absolute top-1/2 left-2 transform -translate-y-1/2 lg:w-6 lg:h-6 w-5 h-5 rounded-full bg-white border border-tenken-gray-300 cursor-pointer"
        style={{ backgroundColor: selectedColor }}
        onClick={() => setShowColorPicker(!showColorPicker)}
      ></div>
      {showColorPicker && (
        <>
          <div style={coverStyle} onClick={handleClose}></div>
          <div
            className={`absolute z-10 left-1/2  ${
              styles
                ? styles
                : "transform -translate-x-1/2 -translate-y-1/2 top-[-160px]"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <SketchPicker
              styles={pickerStyles}
              color={selectedColor}
              onChange={handleColorChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

ColorInput.propTypes = {
  color: PropTypes.string,
  setColor: PropTypes.func,
  width: PropTypes.string,
};

export default ColorInput;
